import { createStyles } from "@material-ui/styles";

const styles = () =>
    createStyles({
        criteriaContainer: {
            marginTop: 16
        },
        invalidPassowrd: {
            color: "#ff0c0c",
            fontSize: 12,
            textAlign: "right",
            marginTop: 2
        },
        label: {
            fontSize: 12,
            fontWeight: "bold",
            marginBottom: 8
        },
        visualizer: {
            fontSize: 12
        },
        untouched: {
            color: "inherit"
        },
        valid: {
            color: "#36a65d"
        },
        invalid: {
            color: "#ff0c0c"
        },
        wrapper: {
            display: "flex",
            alignItems: "center",
            marginBottom: 8
        },
        icon: {
            display: "flex",
            alignItems: "center",
            fontSize: 12,
            justigfyContent: "center",

            "& span": {
                display: "flex"
            }
        },
        text: {
            display: "flex",
            alignItems: "center",
            flex: 1
        },
        checkmark: {
            fontSize: 18,
            position: "relative",
            left: -4,
            marginRight: -2
        },
        circle: {
            fontSize: 8,
            opacity: 0.2,
            color: "#003764",
            marginRight: 8
        }
    });

export default styles;



// WEBPACK FOOTER //
// ./src/components/StartContainer/components/passwordField.style.js